import { styled } from '@linaria/react';

export const MessageListContainer = styled.div<{
	currentlyGenerating?: boolean;
}>`
	--message-fz: 18px;
	--message-gap: 20px;
	display: flex;
	flex: 1;
	margin-bottom: ${({ currentlyGenerating }) =>
		currentlyGenerating ? '0px' : '-20px'};
	contain: strict;
	gap: 0;
	grid-area: history;
	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
	transform: scaleY(-1);
`;

export const MessageListInner = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	font-size: 0;
	line-height: 0;
`;

export const MessageListItem = styled.div`
	color: var(--color-white-solid);
	font-size: var(--message-fz);
	line-height: calc(var(--message-fz) + 6px);
`;

export const MessageGroupTitle = styled.div`
	padding: 10px 0;
	color: var(--color-white-m);
	font-size: var(--font-size-base);
	font-weight: var(--font-weight-light);
	text-align: center;
	text-transform: uppercase;
	user-select: none;
	span {
		display: inline-block;
		padding: calc(var(--base-gap) / 4) var(--base-gap);
		border-radius: var(--radius-xl);
		background-color: var(--color-white-xs);
		pointer-events: all;
	}
`;
